var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeaker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.09052 8.35388C6.58687 8.0577 6.40616 8.08753 6.40616 7.49578C6.40616 7.28867 6.40616 6.90385 6.40616 6.54884C6.68259 6.25306 6.78312 6.28988 7.01689 5.1286C7.48959 5.1286 7.45897 4.53685 7.68193 4.01194C7.86366 3.58449 7.71143 3.41119 7.55836 3.34036C7.68348 1.78266 7.68349 0.70983 5.84851 0.377018C5.18338 -0.172287 4.17971 0.0142052 3.70408 0.105869C3.22887 0.197533 2.80019 0.105869 2.80019 0.105869L2.88183 0.843916C2.18594 1.64857 2.53393 2.7214 2.42189 3.34976C2.2759 3.4264 2.1442 3.6031 2.31805 4.01194C2.54099 4.53685 2.51036 5.1286 2.98309 5.1286C3.21686 6.28988 3.31737 6.25306 3.59382 6.54884C3.59382 6.90385 3.59382 7.28867 3.59382 7.49578C3.59382 8.08753 3.38509 8.09773 2.90949 8.35388C1.76281 8.97143 0.268559 9.33024 0.000839767 11.2604C-0.0481992 11.6134 2.05551 11.9988 4.99999 12C7.94447 11.9988 10.0481 11.6134 9.99916 11.2604C9.73144 9.33024 8.2235 9.01985 7.09052 8.35388Z",
    fill: "#FFAE24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeaker);
export default __webpack_public_path__ + "static/media/speaker.c9b00163b026a63081b62e6c41a6db7e.svg";
export { ForwardRef as ReactComponent };